<template>
    <div class="c-preloader">
        <span class="c-preloader__icon"></span>
        <p class="c-preloader__text">{{ preloaderText }}</p>
    </div>
</template>

<script>
    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Imports
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */


    /*
        +---+---+---+--+---+--+---+---+---+---+---+
    
                    Component Instance
    
        +---+---+---+--+---+--+---+---+---+---+---+
    */
    export default {
        props: {
            preloaderText: { type: String, default: 'Lorem ipsum.' }
        }
    };
</script>

<style scoped src="@/css/components/c-preloader.css"></style>